import script from "./createMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./createMaterial.vue?vue&type=script&setup=true&lang=js"

import "./createMaterial.vue?vue&type=style&index=0&id=dabe3f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dabe3f04"]])

export default __exports__